import React from "react";

export default function Loader() {
  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-center 
      bg-white/20 dark:bg-black/60 z-50"
    >
      {/* Brand/Title */}
      <div
        className="text-[#A03072] dark:text-[#E25BB7]
        text-xl font-semibold tracking-wide mb-4 animate-pulse"
      >
        Loading...
      </div>

      {/* Loader Bar */}
      <div className="w-16 h-1.5 bg-[#A03072]/30 dark:bg-[#E25BB7]/30 rounded-full overflow-hidden">
        <div
          className="w-6 h-1.5 bg-[#A03072] dark:bg-[#E25BB7]
          animate-[slide_1s_ease-in-out_infinite]"
        />
      </div>

      {/* Animation */}
      <style>
        {`@keyframes slide {
            0% { transform: translateX(0); }
            50% { transform: translateX(200%); }
            100% { transform: translateX(0); }
        }`}
      </style>
    </div>
  );
}
